import { RouteLocationNormalized } from 'vue-router'
import store from '@/store'
import Urls from '@/lib/urls'
import userGetters from '@/store/userModule/getterTypes'

export const applyAuthenticationRequired = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next
) => {
  const user = store.getters[userGetters.USER.NAMESPACED]

  if (to.meta?.authRequired && !user) {
    next({
      name: 'logIn',
      query: to.name !== 'logIn' ? { redirect: Urls.app(to.fullPath) } : null,
    })

    return false
  } else {
    return true
  }
}

export default applyAuthenticationRequired
